import React, { useState } from 'react';
import { useField } from 'formik';
import { Form } from 'react-bootstrap';

import Group from '../Group';
import { useChange } from '../hooks';
import { FormTextareaFieldProps } from '../types';

type Props = {
  onLine?: boolean;
  isRequired?: boolean;
};

const Textarea: React.FC<Props & FormTextareaFieldProps> = ({
  onLine = false,
  label,
  isRequired = false,
  helpText,
  ...props
}) => {
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const [{ name, value, onBlur }, { error, touched }] = useField(props);
  const handleChange = useChange(props);
  const isInvalid = Boolean(error) && touched;

  const handleFocus = () => {
    setIsFocus(true);
  };

  const handleBlur = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onBlur(e);
    setIsFocus(false);
  };

  return (
    <Group
      name={name}
      controlId={name}
      label={label}
      error={error}
      isInvalid={isInvalid}
      onLine={onLine}
      isFocus={isFocus}
      className={props.className}
      isRequired={isRequired}
    >
      <Form.Control
        {...props}
        as="textarea"
        rows={3}
        name={name}
        value={value?.toString() || ''}
        isInvalid={isInvalid}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
    </Group>
  );
};

export default Textarea;
